var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHuaweiStore = function SvgHuaweiStore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.734 0C1.80341 0 0 1.80309 0 6.73269V17.2673C0 22.1969 1.80341 24 6.734 24H17.2628C22.1932 24 24 22.1969 24 17.2673V6.73269C24 1.80309 22.1966 0 17.266 0H6.734Z",
    fill: "url(#huawei_store_svg__paint0_linear_20_7887)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3593 14.0566H11.3917L10.8737 12.8521L10.3593 14.0566ZM10.1051 14.6636L9.79882 15.3644H9.10151L10.5844 12.0002H11.187L12.6639 15.3644H11.948L11.6457 14.6636H10.1051ZM21.326 15.362H22V12H21.326V15.362ZM18.6436 13.9177H19.8859V13.3047H18.6436V12.6157H20.4471V12.0025H17.9699V15.3642H20.5119V14.751H18.6436V13.9177ZM15.9658 14.3149L15.2017 12H14.6441L13.88 14.3149L13.1364 12.0019H12.4093L13.5828 15.3663H14.1481L14.9134 13.1563L15.6787 15.3663H16.2489L17.4193 12.0019H16.711L15.9658 14.3149ZM8.07269 13.927C8.07269 14.4743 7.80091 14.7667 7.30738 14.7667C6.81115 14.7667 6.53793 14.4658 6.53793 13.9037V12.0023H5.85487V13.927C5.85487 14.8738 6.38106 15.4167 7.29807 15.4167C8.22418 15.4167 8.75512 14.8635 8.75512 13.8989V12.0002H8.07269V13.927ZM4.22525 12.0002H4.9079V15.3665H4.22525V13.9994H2.68306V15.3665H2V12.0002H2.68306V13.3581H4.22525V12.0002Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 4C8 6.20914 9.79086 8 12 8C14.2091 8 16 6.20914 16 4H15.2C15.2 5.76731 13.7673 7.2 12 7.2C10.2327 7.2 8.8 5.76731 8.8 4H8Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "huawei_store_svg__paint0_linear_20_7887",
    x1: 1200,
    y1: 0,
    x2: 1200,
    y2: 2400,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB6361"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ED3E45"
  })))));
};
export default SvgHuaweiStore;